class RoleOptionController {
    constructor(toastr, DynamicMenuServiceApi, DynamicMenuConfigServiceApi) {
        this.$onInit = function () {
            this.roleOptions = null;
            this.renderRoleOptions();
        };
        this.renderRoleOptions = () => {
            this.DynamicMenuServiceApi.roleOptions().then((response) => {
                let roleOptions = response.data;
                this.roleOptions = roleOptions;
            }, (response) => {
                this.toastr.warning(response.data);
            });
        };
        this.adminToggle = (roleOption) => {
            if (!roleOption) {
                this.toastr.warning('You must provide a role option');
            }
            roleOption.AdminEnabled = !roleOption.AdminEnabled;
            this.DynamicMenuServiceApi.updateRoleMenuOption(roleOption).then((response) => {
                this.renderRoleOptions();
            }, (response) => {
                this.toastr.warning(response.data);
            });
        };
        this.supportToggle = (roleOption) => {
            if (!roleOption) {
                this.toastr.warning('You must provide a role option');
            }
            roleOption.SupportEnabled = !roleOption.SupportEnabled;
            this.DynamicMenuServiceApi.updateRoleMenuOption(roleOption).then((response) => {
                this.renderRoleOptions();
            }, (response) => {
                this.toastr.warning(response.data);
            });
        };
        this.resetToDefaults = () => {
            this.DynamicMenuConfigServiceApi.resetToDefaults().then((response) => {
                this.toastr.info('Reset to Defaults');
                this.renderRoleOptions();
            }, (response) => {
                this.toastr.warning(response.data);
            });
        };
        this.toastr = toastr;
        this.DynamicMenuServiceApi = DynamicMenuServiceApi;
        this.DynamicMenuConfigServiceApi = DynamicMenuConfigServiceApi;
    }
}
angular.module('app').component('roleOptions', {
    templateUrl: 'Scripts/App/partials/Features/role-options.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: RoleOptionController
});
